"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const mobx_react_1 = require("mobx-react");
const BrandBox_1 = require("./Elements/BrandBox");
const Filters_laitepalvelu_1 = require("./Elements/Filters-laitepalvelu");
const Store_1 = require("./Store");
let BrandList = class BrandList extends React.Component {
    componentDidMount() {
        document.title = Store_1.default.currentPageName + " | Hartwall";
    }
    render() {
        return (React.createElement("div", { className: "o-container" },
            React.createElement(Filters_laitepalvelu_1.default, { headerText: "", ingressText: "" }),
            React.createElement("div", { className: "o-product-listing-wrapper" },
                Store_1.default.loading &&
                    React.createElement("div", { className: "ui active inverted dimmer" },
                        React.createElement("div", { className: "ui text loader" }, Store_1.default.Translations.loadingText)),
                React.createElement("div", { className: "row u-mb-10" }, Store_1.default.Brands && Store_1.default.Brands.map(function (brand) {
                    return (React.createElement(BrandBox_1.default, Object.assign({ key: brand.id }, brand)));
                })))));
    }
};
BrandList = __decorate([
    mobx_react_1.observer
], BrandList);
exports.default = BrandList;
